export type CompanionTrail={ownerX:number;offset:number};
/** Render-only trailing offset in facing-independent rig space; never a combat origin. */
export function followCompanion(previous:CompanionTrail|undefined,input:{ownerX:number;facing:number;speed:number;seconds:number}):CompanionTrail{
 const facing=input.facing<0?-1:1,speed=Math.max(0,Math.min(400,Math.abs(input.speed))),distance=48+Math.min(24,speed*.06),target=-facing*distance;
 if(!previous||Math.abs(input.ownerX-previous.ownerX)>180)return{ownerX:input.ownerX,offset:target};
 const seconds=Math.max(0,Math.min(.1,input.seconds)),offset=previous.offset+(target-previous.offset)*(1-Math.exp(-8*seconds));
 return{ownerX:input.ownerX,offset:speed<1&&Math.abs(offset)<48?-facing*48:Math.max(-72,Math.min(72,offset))};
}
